import { TraitChart } from './trait-chart';

export * from './trait-chart-props';
export * from './trait-chart-utils';

export default TraitChart;
